
import { defineComponent, ref } from "vue";

const props = {
  msg: String,
};

const HelloWorld = defineComponent({
  name: "Hello World",
  props: props,
  setup(props) {
    let msg1 = ref(props.msg);
    const name = ref("John Doe");
    return { msg1, name };
  },
});
export default HelloWorld;
